import { useEffect, useState } from 'react'
import classNames from 'classnames'
import { useRouter } from 'next/router'
import { Accordion } from '~/components/Accordion'
import { SectionContainer } from '~/components/SectionContainer'
import Typography, {
  TypographyTag,
  TypographyVariant,
} from '~/components/Typography'
import { ProductReviews } from '~/sections/ProductDetails/ProductReviews'
import { ProductArticles } from './ProductArticles'
import styles from './ProductDetails.module.scss'
import { ProductDetailsProps } from './ProductDetails.types'
import ProductDownloads from './ProductDownloads'
import ProductOverview from './ProductOverview'
import ProductSpecifications from './ProductSpecifications'

const ProductDetails = ({
  articles,
  specification,
  overview,
  downloads,
  reviews,
  width = 'medium',
}: ProductDetailsProps) => {
  const [defaultValue, setDefaultValue] = useState(['Overview'])
  const { asPath } = useRouter()
  useEffect(() => {
    const hash = asPath.split('#')[1]
    if (hash === 'reviews') {
      setDefaultValue(['Overview', 'Reviews'])
    }
  }, [asPath])

  const panels = [
    {
      name: 'Overview',
      header: (
        <Typography variant={TypographyVariant.Heading4} tag={TypographyTag.h2}>
          Overview
        </Typography>
      ),
      content: <ProductOverview {...overview} />,
    },
  ]

  if (specification?.items?.length > 0) {
    panels.push({
      name: 'Specifications',
      header: (
        <Typography variant={TypographyVariant.Heading4} tag={TypographyTag.h2}>
          Specifications
        </Typography>
      ),
      content: <ProductSpecifications {...specification} />,
    })
  }

  if (downloads?.items?.length > 0) {
    panels.push({
      name: 'Downloads',
      header: (
        <Typography variant={TypographyVariant.Heading4} tag={TypographyTag.h2}>
          Downloads
        </Typography>
      ),
      content: <ProductDownloads {...downloads} />,
    })
  }

  if (articles?.items?.length > 0) {
    panels.push({
      name: 'Articles',
      header: (
        <Typography variant={TypographyVariant.Heading4} tag={TypographyTag.h2}>
          Articles
        </Typography>
      ),
      content: <ProductArticles {...articles} />,
    })
  }

  if (reviews?.bazaarVoice?.productIdentifier) {
    panels.push({
      name: 'Reviews',
      header: (
        <Typography variant={TypographyVariant.Heading4} tag={TypographyTag.h2}>
          <div id='reviews'>Reviews</div>
        </Typography>
      ),
      content: <ProductReviews bazaarVoice={reviews.bazaarVoice} />,
    })
  }

  return (
    <SectionContainer width={width}>
      <div className={classNames(styles.root, 'border-t mb-14 md:mb-20')}>
        <Accordion
          theme={{
            title: styles.title,
            content_inner: styles.content_inner,
            control: 'px-0 py-10 !bg-white',
            icon: styles.icon,
          }}
          variant='default'
          panels={panels}
          multiple
          defaultValue={defaultValue}
        />
      </div>
    </SectionContainer>
  )
}

export { ProductDetails }
